export {default} from "./Copyright";
